export default __webpack_public_path__ + "static/bumpa-before-onboarding-cdca67c5a79b1252e727f4604efeb8ff.mp4";